import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { H4 } from 'foundations-components/transitional/components/H4';
import { getIsRememberThisDeviceModalOpen } from 'LoginUI/selectors/TwoFactorAuth';
import { Header } from 'LoginUI/components/Header';
import { Footer } from 'LoginUI/components/Footer';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { useIsMobileLogin } from 'LoginUI/context/MobileLoginContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RememberThisDevice = ({
  onRemember,
  onRememberNot
}) => {
  const isOpen = useSelector(getIsRememberThisDeviceModalOpen);
  const isMobileLogin = useIsMobileLogin();
  if (!isOpen) return null;
  return /*#__PURE__*/_jsxs(Modal, {
    use: "fullscreen",
    children: [/*#__PURE__*/_jsx(Header, {
      hideBackToLogin: true,
      isMobileLogin: isMobileLogin
    }), /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "column",
      justify: "start",
      children: [/*#__PURE__*/_jsxs(View, {
        inlineSize: "480px",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "twoFactorV4.rememberMe.title"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.rememberMe.description"
        })]
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        marginBlockStart: "600",
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "2fa-remember-me-button",
          use: "primary",
          onClick: onRemember,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "twoFactorV4.rememberMe.rememberMeButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "2fa-remember-me-not-button",
          use: "secondary-alt",
          onClick: onRememberNot,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "twoFactorV4.rememberMe.rememberMeNotButton"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};